import { useGetAllPageMenuPromoBannersQuery } from './generated';
import { sanityLanguage } from '@/constants/language';
import { LinkProps } from '@/components/links';

export type PageMenuPromoBanner = {
	sectionId?: string;
	path: string;
	image: {
		src: string;
		alt: string;
	};
	target?: LinkProps['target'];
};

export async function getAllPageMenuPromoBanners(): Promise<PageMenuPromoBanner[]> {
	const fetchPageMenuPromoBanners = useGetAllPageMenuPromoBannersQuery.fetcher({
		i18nLang: sanityLanguage,
	});

	const promoBannersResponse = await fetchPageMenuPromoBanners();

	return promoBannersResponse.allPageMenuPromoBanner
		.map((banner) => {
			if (!banner?.sectionId || !banner?.path || !banner?.image?.asset?.url) {
				return null;
			}
			return {
				sectionId: banner.sectionId,
				path: banner?.path || '',
				image: {
					src: banner?.image.asset.url,
					alt: banner?.title || 'Promo',
				},
				target: (banner.target as LinkProps['target']) || '_self',
			};
		})
		.filter(Boolean);
}
